import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TextAreaControl } from 'src/app/form-controls/textarea/textarea.control';
import { SheetItemService } from 'src/app/services/sheet-item.service';
import { ItemTypeMetadata, SheetItemFormBase } from 'src/app/services/sheets-renderer.service';
import { Row } from 'src/app/types/aggregate-graph.types';
import { BloodSampleInstructionV2 } from 'src/app/types/sheet-instruction.types';
import { InstructionsFormComponent } from '../../instructions-form/instructions-form.component';

interface BloodSampleInstructionFormGroup {
	testDetails: FormControl<string | null>;
}

@Component({
    selector: 'app-blood-sample-item-form-v2',
    templateUrl: './blood-sample-item-form-v2.component.html',
    styleUrl: './blood-sample-item-form-v2.component.scss',
    imports: [ReactiveFormsModule, InstructionsFormComponent, TextAreaControl],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BloodSampleItemFormComponentV2 implements SheetItemFormBase, OnInit {

	@Input() instructionTypeName!: string;
	@Input() item!: Row | null;
	@Input() minDate!: string;
	@Input() maxDate!: string;
	@Input() instructionsFormArray!: FormArray;
	@Input() itemConfig!: ItemTypeMetadata;

	constructor(private sheetItemService: SheetItemService, private formBuilder: FormBuilder) {
	}

	ngOnInit() {
		this.sheetItemService.getInstructions(this.item, this.instructionTypeName, this.itemConfig.scheduleConfig.defaultScheduleType, this.itemConfig.scheduleConfig.defaultRepeatingScheduleFrequency).forEach(instruction => {
			const group: FormGroup<BloodSampleInstructionFormGroup> = this.sheetItemService.buildExistingInstructionGroup(this.instructionTypeName, instruction);
			const bloodSampleInstruction = instruction as BloodSampleInstructionV2;
			group.addControl('testDetails', this.formBuilder.control(bloodSampleInstruction.testDetails ?? null));
			this.instructionsFormArray.push(group);
		});
	}

	addInstruction() {
		const group: FormGroup<BloodSampleInstructionFormGroup> = this.sheetItemService.getNewInstructionGroup(this.instructionTypeName, this.itemConfig.scheduleConfig.defaultScheduleType, this.itemConfig.scheduleConfig.defaultRepeatingScheduleFrequency);
		group.addControl('testDetails', this.formBuilder.control(null));
		this.instructionsFormArray.push(group);
	}
}